// extracted by mini-css-extract-plugin
export var main = "style-module--main--9bff5";